import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class RestaurantService {
  public suggestedByBot: Object[] = [];
  restaurant: Object;
  restaurantChanged: EventEmitter<Object> = new EventEmitter();

  constructor(public http: HttpClient) {}

  public getDashboard(restaurantId: number, params: Object) {
    return this.http.get(`${API_URL}/api/v1/restaurants/${restaurantId}/dashboard`, params);
  }

  public getMenu(restaurantId: number) {
    return this.http.get(`${API_URL}/api/v1/restaurants/${restaurantId}/menu`);
  }

  public search(params: Object) {
    return this.http.post(`${API_URL}/api/v1/restaurants/search`, params);
  }

  public setRestaurant(data: Object) {
    this.restaurant = data;
    this.restaurantChanged.emit(this.restaurant);
  }
}



// WEBPACK FOOTER //
// ./src/providers/restaurants.ts